import { useQuery } from '@tanstack/react-query';
import { listQueryDefaults } from '../../../lib/query/listQuery';
import { getDailyTaskTracking, type GetDailyTaskTrackingParams } from '../api/dailyTaskTracking';

export function useDailyTaskTracking(params?: GetDailyTaskTrackingParams) {
  return useQuery({
    queryKey: ['daily-task-tracking', JSON.stringify(params ?? {})],
    queryFn: () => getDailyTaskTracking(params),
    ...listQueryDefaults,
  });
}
